module.exports = __webpack_public_path__ + "static/media/01-quote-01-tiffani-co@2x.34939524.jpg";